import { client } from './client';

const search = {
    destinations: (body: Api.Search.Destinations.Body) => {
        return client<Api.Search.Destinations.Response>('/search/destinations', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    hotels: (body: Api.Search.Hotels.Body) => {
        return client<Api.Search.Hotels.Response>('/search/hotels', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    filters: () => {
        return client<Api.Search.Filters.Response>('/search/filters', { method: 'POST' });
    }
};

const hotel = {
    rooms: (body: Api.Hotel.Rooms.Body) => {
        return client<Api.Hotel.Rooms.Response>('/hotel/rooms', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    }
};

const booking = {
    prebook: (body: Api.Booking.Prebook.Body) => {
        return client<Api.Booking.Prebook.Response>('/booking/prebook', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    }
};

const order = {
    info: () => {
        return client<Api.Order.Info.Response>('/order/info', { method: 'POST' });
    },
    // What cancelling would mean (deadline, paid amount, expected refund),
    // shown before the customer confirms.
    cancelPreview: (body: Api.Order.Cancel.Body) => {
        return client<{ data: Api.Order.Cancel.Preview | null; error: string | null; message?: string }>('/order/cancel/preview', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    cancel: (body: Api.Order.Cancel.Body) => {
        return client<Api.Order.Cancel.Response>('/order/cancel', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    }
};

const auth = {
    google: (body: Api.Auth.Google.Body) => {
        return client<Api.Auth.Google.Response>('/auth/google', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    logout: () => {
        return client<Api.Auth.Logout.Response>('/auth/logout', { method: 'POST' });
    }
};

const cms = {
    list: () => {
        return client<Api.Cms.List.Response>('/cms', { method: 'GET' });
    },
    update: (body: Api.Cms.Update.Body) => {
        return client<Api.Cms.Update.Response>('/admin/cms/update', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    previewImport: (body: Api.Cms.ImportPreview.Body) => {
        return client<Api.Cms.ImportPreview.Response>('/admin/cms/import/preview', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    publishImport: (body: Api.Cms.ImportPublish.Body) => {
        return client<Api.Cms.ImportPublish.Response>('/admin/cms/import/publish', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    reset: (body?: Api.Cms.Reset.Body) => {
        return client<Api.Cms.Reset.Response>('/admin/cms/reset', {
            method: 'POST',
            body: JSON.stringify(body ?? {})
        });
    }
};

const support = {
    create: (body: Api.Support.Create.Body) => {
        return client<Api.Support.Create.Response>('/support/tickets/create', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    my: (body?: Api.Support.My.Body) => {
        return client<Api.Support.My.Response>('/support/tickets/my', {
            method: 'POST',
            body: JSON.stringify(body ?? {})
        });
    },
    message: (body: Api.Support.Message.Body) => {
        return client<Api.Support.Message.Response>('/support/tickets/message', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    }
};

const admin = {
    overview: () => {
        return client<Api.Admin.Overview.Response>('/admin/overview', { method: 'POST' });
    },
    users: (body?: Api.Admin.Users.Body) => {
        return client<Api.Admin.Users.Response>('/admin/users', {
            method: 'POST',
            body: JSON.stringify(body ?? {})
        });
    },
    setRole: (body: Api.Admin.Role.Body) => {
        return client<Api.Admin.Role.Response>('/admin/users/role', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    bookings: (body?: Api.Admin.Bookings.Body) => {
        return client<Api.Admin.Bookings.Response>('/admin/bookings', {
            method: 'POST',
            body: JSON.stringify(body ?? {})
        });
    },
    cancelBooking: (body: Api.Admin.CancelBooking.Body) => {
        return client<Api.Admin.CancelBooking.Response>('/admin/bookings/cancel', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    tickets: (body?: Api.Admin.Tickets.Body) => {
        return client<Api.Admin.Tickets.Response>('/admin/tickets', {
            method: 'POST',
            body: JSON.stringify(body ?? {})
        });
    },
    replyTicket: (body: Api.Admin.ReplyTicket.Body) => {
        return client<Api.Admin.ReplyTicket.Response>('/admin/tickets/reply', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    setTicketStatus: (body: Api.Admin.TicketStatus.Body) => {
        return client<Api.Admin.TicketStatus.Response>('/admin/tickets/status', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    searchHotels: (body: Api.Admin.SearchHotels.Body) => {
        return client<Api.Admin.SearchHotels.Response>('/admin/hotels/search', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    }
};

const payment = {
    initiate: (body: Api.Payment.Initiate.Body) => {
        return client<Api.Payment.Initiate.Response>('/payment/initiate', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    status: (body: Api.Payment.Status.Body) => {
        return client<Api.Payment.Status.Response>('/payment/status', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    }
};

const currency = {
    rates: () => {
        return client<Api.Currency.Rates.Response>('/currency/rates', { method: 'GET' });
    }
};

const api = { search, hotel, booking, payment, order, auth, cms, support, admin, currency };

export { api };
